import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu"
import { Button } from "@/components/ui/button"
import { MoreVertical, Info, Trash } from "lucide-react"
function DropDownMenu({ 
  dropdownOpen, 
  setDropdownOpen, 
  isActive, 
  setShowInfo, 
  setShowRemove 
}: {
  dropdownOpen: boolean, 
  setDropdownOpen: (open: boolean) => void, 
  isActive: boolean, 
  setShowInfo: (open: boolean) => void, 
  setShowRemove: (open: boolean) => void 
}) {
  return (
    <DropdownMenu open={dropdownOpen} onOpenChange={setDropdownOpen}>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="icon">
          <MoreVertical className="size-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {isActive && (
          <DropdownMenuItem 
            onSelect={() => {
              setDropdownOpen(false);
              setTimeout(() => setShowInfo(true), 100);
            }}
          >
            <Info className="size-4 mr-2" />
            DNS Configurations
          </DropdownMenuItem>
        )}
        <DropdownMenuItem 
          onSelect={() => {
            setDropdownOpen(false);
            setTimeout(() => setShowRemove(true), 100);
          }}
          className="text-red-600 focus:text-red-600"
        >
          <Trash className="size-4 mr-2" />
          Delete
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

export default DropDownMenu